module.exports = __webpack_public_path__ + "static/media/13.Stand with Puppets.f53e8f76.JPG";